<mat-form-field fxFlex="70%" fxLayoutGap="20px" fxFlexOffset="20px">
    <mat-label>Unidade</mat-label>
    <mat-select [(ngModel)]="rateio.idUnidade"
                name="unidade_{{pinUnidade}}"
                #campoUnidade
                [required]="!rateio.idUnidade"
                (selectionChange)="validarDuplicado()">
        <mat-option></mat-option>
        <mat-option *ngFor="let i of unidades" [value]="i.idUnidade">
            {{i.nomeUnidade}}
        </mat-option>
    </mat-select>
    <mat-hint *ngIf="unidades?.length === 0" align="start">Nenhum unidade cadastrada</mat-hint>
</mat-form-field>

<mat-form-field fxFlex fxFlexOffset="20px">
    <input [(ngModel)]=rateio.valorRateio 
           currencyMask 
           name="valor_{{pinValor}}"
           placeholder={{rateio.placeHolderRateio}}
           matInput 
           maxlength="13"
           [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
    <span matPrefix *ngIf="!rateio.statusPercentual">R$&nbsp;</span>
    <span matSuffix *ngIf="rateio.statusPercentual" style="padding-left: 5px;">%&nbsp;</span>
</mat-form-field> 

<div fxFlex="10%" style="margin-top: 18px;margin-left: 26px;" >
    <mat-checkbox color="primary"
                  title="Escolha a forma de rateio entre % ou R$" 
                  name="checkRateio_{{pinCheckRateio}}" 
                  [(ngModel)]="rateio.statusPercentual">
        (%)
    </mat-checkbox>

    <button mat-icon-button 
            *ngIf="perfilAcesso.deleta" 
            (click)="deletarRateio()"
            style="padding: 0px;">
        <mat-icon>delete_forever</mat-icon>
    </button>                                
</div>
